import Table from '@/components/table/index.vue'

export default {
  install(app) {
    app.component(Table.name, Table)
  }
}